import { useSelector } from "react-redux";
import { fetchAuthPost } from "../functions/functions";
import api from "../routes/api";
import { useEffect, useState } from "react";

export default function PageName({ titleName, subtitleName }) {
  const { msg } = useSelector((state) => state.language);

  const [ltdName, setLtdName] = useState(
    localStorage.getItem("ltdName") || msg.inverz_solutions_co_ltd
  );

  const loadOrganizationData = async () =>
    await fetchAuthPost(api.setting.readOrganization)
      .then((r) => r.data)
      .then((r) => {
        const company_name_english = r.company.company_name_english;
        localStorage.setItem("ltdName", company_name_english);
        setLtdName(company_name_english);
      });

  useEffect(() => {
    if (ltdName !== localStorage.getItem("ltdName")) {
      loadOrganizationData();
    }
  }, []);

  return (
    <div className="_page_name">
      <h1>{titleName || msg.welcome}</h1>
      <p>
        {subtitleName ||
          localStorage.getItem("ltdName") ||
          ltdName ||
          msg.inverz_solutions_co_ltd}
      </p>
      {/* <p>{subtitleName || ltdName}</p> */}
    </div>
  );
}
